import create from 'zustand';
import { unset } from 'lodash';

/**
 * To Store Catalog settings
 * @type {UseStore<{getTargetString: function(): string, setTarget: function(*, string=, string=): void, targets: {ngb: {pt: string}, lccw: {main: string}}}>}
 */
export const useCatSettings = create((set, get) => ({
    targets: {
        dkcw: {
            main: {},
        },
        kt: {
            d: {},
        },
        lccw: {
            main: {},
        },
        ngb: {
            pt: {},
        },
    },
    targTitles: {},
    targString: '', // All of all collections: lccw_ngb-pt_kt-d
    addITXTarget: (coll, ed, vnum = 'all', tnum = '', ttitle = '') => {
        if (!coll || !ed) {
            console.log('Not adding itx target');
            return false;
        }
        /*
        console.log(
            'coll, ed, vnum, tnum, ttitle: ' + coll,
            ed,
            vnum,
            tnum,
            ttitle
        );
         */
        const excludevol = String(vnum)?.startsWith('-');
        const excludetext = String(tnum)?.startsWith('-');
        // console.log('excludevol, excludetext', excludevol, excludetext);
        // Get Current Targets
        const targs = get().targets;

        // Current list of volumes and texts added for targets in this edition.
        let edVols = coll in targs && ed in targs[coll] ? targs[coll][ed] : {};

        // Create the target strings per volume depending on this function's parameters
        if (vnum === 'all') {
            // if all collection, then the volume list is either ['all'] is adding or empty is removing
            edVols = { all: true };
        } else if (!isNaN(vnum) && Number.isInteger(Number(vnum))) {
            // If adding a text in a vol, then text is either "all" or a text number"
            const vnumz = String(vnum).replace('-', '').padStart(3, '0');
            const voldata = { ...edVols[vnumz] };
            //console.log(' adding itx target vnum is: ', vnum, 'Text is', tnum);
            if (tnum === 'all') {
                edVols = {
                    ...edVols,
                    [vnumz]: { all: true, exclude: excludevol },
                };
            } else if (!isNaN(tnum) && Number.isInteger(Number(tnum))) {
                const tnumz = String(tnum).replace('-', '').padStart(4, '0');
                // const volexclude = voldata?.exclude || false;
                const newvoldata = {
                    ...voldata,
                    [tnumz]: {
                        title: ttitle,
                        exclude: excludetext,
                    },
                    exclude: excludevol,
                };
                edVols = { ...edVols, [vnumz]: newvoldata };
            }
        }
        const newTargets = {
            ...targs,
            [coll]: {
                ...targs[coll],
                [ed]: edVols,
            },
        };
        set((state) => ({ targets: newTargets }));
        //console.log('New targets are', newTargets);
        get().setTargetString();
    },
    allSelected: () => {
        let allSelected = true;
        const targs = get().targets;
        for (const coll in targs) {
            for (const ed in targs[coll]) {
                if (targs[coll][ed]?.all !== true) {
                    allSelected = false;
                }
            }
        }
        return allSelected;
    },
    chooseAllITXTargets: (select = true) => {
        const targs = get().targets;
        let newTargets = { ...targs };
        for (const coll in targs) {
            for (const ed in targs[coll]) {
                newTargets[coll][ed] = targs[coll][ed] = select
                    ? { all: true }
                    : {};
            }
        }
        set((state) => ({ targets: newTargets }));
        get().setTargetString();
    },
    isITXTarget: (coll, ed, vnum = '', tnum = '') => {
        if (!(coll && ed)) {
            return false;
        }
        const targs = get().targets;
        vnum = String(vnum);
        if (vnum == '') {
            return targs?.[coll]?.[ed]?.all === true;
        }
        if (/^\d/.test(vnum)) {
            vnum = String(vnum).padStart(3, '0');
        }

        tnum = String(tnum);

        if (tnum === '') {
            return targs?.[coll]?.[ed]?.[vnum]?.all === true;
        }
        if (/^\d/.test(tnum)) {
            tnum = String(tnum).padStart(4, '0');
        }

        return targs?.[coll]?.[ed]?.[vnum]?.[tnum] !== undefined;
    },
    removeITXTarget: (collobj, ed, vol = '', tnum = '') => {
        console.log('Should remove: ', collobj, ed, vol, tnum);
        const coll = typeof collobj === 'string' ? collobj : collobj?.coll;
        const targs = get().targets;
        let newTargets = {};
        if (tnum === '' || tnum === 'all') {
            // no text given means either...
            if (vol === '') {
                // remove whole edition or
                newTargets = {
                    ...targs,
                    [coll]: {
                        ...targs[coll],
                        [ed]: {},
                    },
                };
            } else {
                const volkey = String(vol).padStart(3, '0');
                console.log('trying to remove', vol);
                // remove volume
                const { [volkey]: _, ...restVols } = targs[coll][ed];
                newTargets = {
                    ...targs,
                    [coll]: {
                        ...targs[coll],
                        [ed]: {
                            ...restVols,
                        },
                    },
                };
            }
        } else {
            // otherwise, if text num given then remove text
            const volkey = String(vol).padStart(3, '0');
            const value = targs?.[coll]?.[ed]?.[volkey]?.[tnum];
            if (value !== undefined) {
                const { [tnum]: _, ...restVol } = targs[coll][ed][volkey];
                newTargets = {
                    ...targs,
                    [coll]: {
                        ...targs[coll],
                        [ed]: {
                            ...targs[coll][ed],
                            [volkey]: restVol,
                        },
                    },
                };
            }
        }
        console.log('New targets in remove', newTargets);
        // If newTargets has been modified (i.e. is not empty) store it and recalculate target string.
        if (Object.keys(newTargets).length > 0) {
            set((state) => ({ targets: newTargets }));
            get().setTargetString();
        }
    },
    setTargetString: () => {
        /*
           - &targets=ngb-pt (Please note no need of .all at the end.)
           - whole volumes as targets: &targets=lccw.~v1~v2~v3
           - select some texts in a volume as targets: &targets=lccw.~v1~0002~0003
           - exclude volumes in coll: &targets=lccw.-v1-v2-v3 The minus sign is used to exclude things.
           - exclude specific texts in vols: &targets=lccw.~v1-0002-0003 The same logic as 3 but the minus signs.
           - multiple collections as targets: &targets=lccw_ngb-pt_kt-d The underscore _ is used to separate between multiple colls.
           - multiple selections across multiple colls as targets: &targets=lccw.~v1~v4+0071+0072_ngb-pt.~v6-0092 Here it selects the whole volume 1 and  the texts 0071 and 0072 in LCCW and all texts but text 0092 in NGB.PT as targets.
        */
        const targs = get().targets;
        //console.log('targs in setting target string: ', targs);

        const newTargList = [];
        for (let coll in targs) {
            for (let ed in targs[coll]) {
                let targparts = [];
                let colled = coll;

                // If ed is "main" there is only one edition in collection, so no sigla used.
                if (ed !== 'main') {
                    colled += '-' + ed;
                }
                for (const [volkey, vol] of Object.entries(targs[coll][ed])) {
                    // if the key begins with a number it's a volume, not a property of the coll
                    if (/^\d/.test(volkey)) {
                        const prefix = vol.exclude ? '-' : '~';
                        const volint = parseInt(volkey);
                        let volstr = `${prefix}v${volint}`;
                        const volitems = Object.entries(vol).sort(
                            ([keyA], [keyB]) => {
                                return keyA.localeCompare(keyB);
                            }
                        );
                        for (const [txtkey, txt] of volitems) {
                            if (/^\d/.test(txtkey)) {
                                const txtpref = txt.exclude ? '-' : '~';
                                volstr += `${txtpref}${txtkey}`;
                            }
                        }
                        targparts.push(volstr);
                    }
                }
                if (Object.keys(targs[coll][ed])?.length > 0) {
                    let newTargString = colled;
                    if (targparts.length > 0) {
                        newTargString += '.' + targparts.join('');
                    }
                    newTargList.push(newTargString);
                }
            }
        }
        // console.log('newtargstr', newTargString);
        set((state) => ({ targString: newTargList.join('_') })); // e.g. lccw_ngb-pt_kt-d (previously lccw.all,ngb-pt.all)
    },
    clearTargets: () => {
        set((state) => ({
            targets: {
                kt: {
                    d: [],
                },
                lccw: {
                    main: [],
                },
                ngb: {
                    pt: [],
                },
            },
            targString: '',
        }));
    },
    useTree: true,
    setUseTree: (val) => {
        set((state) => ({ useTree: val }));
    },
}));
